<template>
  <span/>
</template>

<script>
import XlsxMixin from "../../../mixins/XlsxMixin.js";
import Catalog from "../StopCatalog.js";
import StopItemCatalog from "../StopItemCatalog.js";
import Info from "../StopInfo.js";
import Model from "../StopModel.js";

export default {
  mixins: [XlsxMixin],
  props: {
    access: Object,
    userData: Object
  },
  created() {
    this.$emit(this.$kst.Enum.Event.Init, this.exportExcel);
  },
  methods: {
    exportExcel(data, fileName) {
      this.createBook();
      this.createSheet();

      this.addList(data.List);

      this.download(fileName);
    },

    addList(dataList) {
      // label
      this.addColumnHeader_ID();
      this.addColumnHeader(Catalog.AdjNumber);
      this.addColumnHeader(Catalog.Date);
      this.addColumnHeader_ID(Catalog.WarehouseID.Label);
      this.addColumnHeader(Catalog.WarehouseID);

      if (this.userData.WithItems) {
        this.addColumnHeader_ID(StopItemCatalog.DispatchID.Label);
        this.addColumnHeader(StopItemCatalog.DispatchID);
        this.addColumnHeader(StopItemCatalog.Packaging);
        this.addColumnHeader(StopItemCatalog.Qty);
        this.addColumnHeader(StopItemCatalog.TotalQty);
        if (this.access.Glob_HPP) {
          this.addColumnHeader(StopItemCatalog.HppTotal);
        }
      }

      // value
      for (const row of dataList) {
        this.addRow();

        this.addCellValue_ID(row);
        this.addCellValue("AdjNumber", row, Catalog);
        this.addCellValue("Date", row, Catalog);
        this.addCellValue("WarehouseID", row, Catalog);
        this.addCellRelatedValue("WarehouseID", row, Catalog);

        if (this.userData.WithItems) {
          Model.updateItemReadOnly(row);

          this.addCellValue("DispatchID", row, StopItemCatalog);
          this.addCellRelatedValue("DispatchID", row, StopItemCatalog);
          this.addCellValue("Packaging", row, StopItemCatalog);
          this.addCellValue("Qty", row, StopItemCatalog);
          this.addCellValue("TotalQty", row, StopItemCatalog);
          if (this.access.Glob_HPP) {
            this.addCellValue("HppTotal", row, StopItemCatalog);
          }
        }
      }

      this.addSheet(Info.Export.List.Excel.SheetName.List);
    }
  }
}
</script>